export default __webpack_public_path__ + "static/media/smartCity.032d3849.jpg";